/** Origin for Stripe `confirmPayment` return_url on web signup flows. */
export const getSignupStripeReturnOrigin = (parsedUrl: URL): string =>
  parsedUrl.hostname === "localhost"
    ? parsedUrl.origin
    : `https://${parsedUrl.hostname}`;
